import { render, staticRenderFns } from "./cardsTradeList.vue?vue&type=template&id=8d7d8d94&scoped=true&"
import script from "./cardsTradeList.vue?vue&type=script&lang=js&"
export * from "./cardsTradeList.vue?vue&type=script&lang=js&"
import style0 from "./cardsTradeList.vue?vue&type=style&index=0&id=8d7d8d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7d8d94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer})
